const ASDetail = () => (
  <div className="container my-5">
    <h2>AS - Delaware Technical and Community College</h2>
    <p>Details about Respiratory Care Therapy.</p>
  </div>
);

export default ASDetail;